import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import CoreFeaturedCallout from 'marketplace-ui-common/callouts/components/FeaturedCallout';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'marketplace-ui-common/callouts/constants/FeaturedCallouts';
import { useFeaturedCallouts } from 'marketplace-ui-common/callouts/hooks/useFeaturedCallouts';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { getIsInApp } from '../../selectors/app'; // @ts-expect-error untyped module

import { getIsUngatedForLinguine } from '../../selectors/auth';
import { getThemesStorefrontRoute } from '../../utils/urls';

function FeaturedCallout({
  callout,
  layout,
  onTrackInteraction
}) {
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const isInApp = useSelector(getIsInApp);
  const {
    getCollectionById
  } = useCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const collection = collectionId ? getCollectionById(collectionId) : null;
  const isLinguineUngated = useSelector(getIsUngatedForLinguine);
  const LinkComponent = collection ? UIRouterLink : UILink;
  const link = collection && collection.publishedListing ? getThemesStorefrontRoute(collection.publishedListing.slug) : externalUrl;
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.buttonText,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.buttonText,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.buttonText`
    }),
    description: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.description,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.description,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.description`
    }),
    headline: isLinguineUngated ? /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.headline,
      WrapperComponent: "span"
    }) : /*#__PURE__*/_jsx(ValidI18nMessage, {
      defaultValue: publishedListing.headline,
      message: `marketplace-assets-ui.callouts.featuredCallout_${id}.headline`
    }),
    gradientColor: publishedListing.gradientColor,
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: collection ? {
      to: link
    } : {
      href: link
    },
    onClick: () => {
      onTrackInteraction('click featured callout', {
        section: `featured-callout::${id}::static`
      });
    },
    external: !collection,
    responsive: true
  });
}

export default function CalloutsSection({
  onTrackInteraction
}) {
  const isInApp = useSelector(getIsInApp);
  const {
    data: callouts
  } = useFeaturedCallouts({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const isMobile = useIsMaxScreenSize('sm');
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: "p-top-8 m-top-8 p-bottom-0",
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout,
      onTrackInteraction: onTrackInteraction
    }, callout.id))
  });
}